import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Modal } from "react-bootstrap";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import Swal from "sweetalert2";
import { customStyles } from "../Utility/Utility";
import Loader from "../Loader/Loader";

const ListMarketingcontact = () => {
  const [data, setData] = useState([]);
  const [postModal, setPostModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [formData, setFormData] = useState({
    Name: "",
    Details: "",
  });
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(false);

 
  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await AddUpdate("Categorydetails/GetData_Categorydetails", {
        IsActive: true,
      });

      if (res?.data?.data) {
        const parsed = JSON.parse(res.data.data);
        setData(parsed?.Table || []);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleAdd = () => {
    setIsEdit(false);
    setFormData({ Name: "", Details: "" });
    setPostModal(true);
  };

 
  const handleEdit = (row) => {
    setIsEdit(true);
    setSelectedId(row.Id);
    setFormData({
      Name: row.Name,
      Details: row.Details,
    });
    setPostModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.Name.trim()) {
      Swal.fire("Validation", "Please enter category name", "warning");
      return;
    }
    if (!formData.Details.trim()) {
      Swal.fire("Validation", "Please enter Details", "warning");
      return;
    }


    const apiUrl = isEdit
      ? "Categorydetails/Update_Categorydetails"
      : "Categorydetails/Insert_Categorydetails";

    const payload = isEdit
      ? {
          Id: selectedId,
          Name: formData.Name,
          Details: formData.Details,
          ModifiedByUser:"1",
        }
      : {
          Name: formData.Name,
          Details: formData.Details,
          CreatedByUser: "1",
        };

    try {
      const res = await AddUpdate(apiUrl, payload);
      if (res?.status === 200) {
        Swal.fire(
          "Success",
          isEdit ? "Category updated successfully!" : "Category added successfully!",
          "success"
        );
        setPostModal(false);
        fetchData();
      } else {
        Swal.fire("Error", "Something went wrong", "error");
      }
    } catch (error) {
      console.error("Error saving data:", error);
      Swal.fire("Error", "Something went wrong!", "error");
    }
  };

 
 const handleDelete = async (id) => {
  const confirm = await Swal.fire({
    title: "Are you sure?",
    text: "This category will be deleted!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete it!",
  });

  if (!confirm.isConfirmed) return;


  setData((prev) => prev.filter((item) => item.Id !== id));

  try {
  
    await AddUpdate("Categorydetails/Delete_Categorydetails", {
      Id: id,
      IsActive: false,
      DeleteByUser: "1",
    });

    Swal.fire("Deleted!", "Category deleted successfully!", "success");

    await fetchData();
  } catch (error) {
    console.error("Error deleting data:", error);
    Swal.fire("Error", "Failed to delete category!", "error");

  
    await fetchData();
  }
};

  const columns = [
    {
      name: "S.No",
      selector: (row, index) => index + 1,
      width: "80px",
    },
    {
      name: "Name",
      selector: (row) => row.Name,
      sortable: true,
    },
    {
      name: "Details",
      selector: (row) => row.Details,
      wrap: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <button
            className="btn btn-sm btn-warning me-2"
            onClick={() => handleEdit(row)}
          >
            Edit
          </button>
          <button
            className="btn btn-sm btn-danger"
            onClick={() => handleDelete(row.Id)}
          >
            Delete
          </button>
        </>
      ),
    },
  ];

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 style={{ color: "#f7931e", fontWeight: 700 }}>Contact Category Details</h2>
        <button className="btn btn-primary" onClick={handleAdd}>
          Add Category
        </button>
      </div>


{        loading ? <Loader /> :
      <DataTable
        columns={columns}
        data={data}
        // progressPending={loading}
        pagination
        highlightOnHover
        striped
        dense
        customStyles={customStyles}
      />
}
      <Modal
        show={postModal}
        onHide={() => setPostModal(false)}
        backdrop="static"
        centered
      >
        <form onSubmit={handleSubmit}>
          <div className="modal-header">
            <h4 className="modal-title">
              {isEdit ? "Edit Category" : "Add Category"}
            </h4>
            <button
              type="button"
              className="btn-close"
              onClick={() => setPostModal(false)}
            ></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label">
                Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                name="Name"
                className="form-control"
                value={formData.Name}
                onChange={handleChange}
                autoComplete="off"
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Details <span className="text-danger">*</span></label>
              <textarea
                name="Details"
                className="form-control"
                rows={3}
                value={formData.Details}
                onChange={handleChange}
              ></textarea>
            </div>
          </div>
          <div className="modal-footer">
            <button type="submit" className="btn btn-primary">
              {isEdit ? "Update" : "Save"}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setPostModal(false)}
            >
              Close
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default ListMarketingcontact;
